export const _getItemFromSession = (key) => {
    return window.sessionStorage.getItem(key);
};

export const _setItemInSession = (key, value) => {
    window.sessionStorage.setItem(key, value);
};

export const _removeItemFromSession = (key) => {
    window.sessionStorage.removeItem(key);
};
